<template>
    <div class="car-extra-form">
        <quote-step-header
            :showStep="false"
            :title="$trans('quote.car.user_info.time_to_know')"
            :subtitle="$trans('quote.car.user_info.fill_drivers_info')"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="submit">
            <div class="form-row center">
                <span class="driver-title">{{
                    $trans("quote.car.user_info.youngest_driver")
                }}</span>

                <app-input
                    label="inputs.firstName"
                    :message="
                        errors.get(
                            'CarQuoteDriverInfo.youngestDriver.firstName'
                        )
                    "
                    v-model="
                        extraForm.CarQuoteDriverInfo.youngestDriver.firstName
                    "
                ></app-input>

                <app-input
                    label="inputs.lastName"
                    :message="
                        errors.get('CarQuoteDriverInfo.youngestDriver.lastName')
                    "
                    v-model="
                        extraForm.CarQuoteDriverInfo.youngestDriver.lastName
                    "
                ></app-input>

                <app-input
                    label="inputs.idNumberShort"
                    type="number"
                    :message="
                        errors.get('CarQuoteDriverInfo.youngestDriver.IdNum')
                    "
                    v-model="extraForm.CarQuoteDriverInfo.youngestDriver.IdNum"
                ></app-input>
            </div>

            <div
                v-if="
                    (extraForm.driverCount !== 'one' &&
                        extraForm.driverCount !== 'any') ||
                        (extraForm.driverCount === 'any' &&
                            !extraForm.youngestIsMain)
                "
                class="form-row center"
            >
                <span class="driver-title">{{
                    $trans(`quote.car.user_info.${"main_driver"}`)
                }}</span>

                <app-input
                    label="inputs.firstName"
                    :message="
                        errors.get('CarQuoteDriverInfo.mainDriver.firstName')
                    "
                    v-model="extraForm.CarQuoteDriverInfo.mainDriver.firstName"
                ></app-input>

                <app-input
                    label="inputs.lastName"
                    :message="
                        errors.get('CarQuoteDriverInfo.mainDriver.lastName')
                    "
                    v-model="extraForm.CarQuoteDriverInfo.mainDriver.lastName"
                ></app-input>

                <app-input
                    label="inputs.idNumberShort"
                    type="number"
                    :message="errors.get('CarQuoteDriverInfo.mainDriver.IdNum')"
                    v-model="extraForm.CarQuoteDriverInfo.mainDriver.IdNum"
                ></app-input>
            </div>

            <div class="submit-row">
                <app-button :disabled="!validateInfo" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ["errors", "form", "value", "loading"],
    data() {
        return {
            extraForm: this.value
        };
    },
    created() {},
    watch: {
        extraForm() {
            this.$emit("input", this.extraForm);
        }
    },
    methods: {
        submit() {
            this.$emit("submit");
        }
    },
    computed: {
        validateInfo() {
            return (
                this.extraForm.CarQuoteDriverInfo.youngestDriver.firstName &&
                this.extraForm.CarQuoteDriverInfo.youngestDriver.lastName &&
                this.extraForm.CarQuoteDriverInfo.youngestDriver.IdNum &&
                ((this.extraForm.driverCount !== "one" &&
                    this.extraForm.driverCount !== "any") ||
                (this.extraForm.driverCount === "any" &&
                    !this.extraForm.youngestIsMain)
                    ? this.extraForm.CarQuoteDriverInfo.mainDriver.firstName &&
                      this.extraForm.CarQuoteDriverInfo.mainDriver.lastName &&
                      this.extraForm.CarQuoteDriverInfo.mainDriver.IdNum
                    : true)
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.car-extra-form {
    width: 100%;
    max-width: 830px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .form-row {
        &.start {
            justify-content: flex-start !important;
        }

        @media screen and (max-width: $mobile) {
            display: block !important;
        }
    }

    .driver-title {
        font-weight: bold;
        min-width: 99px;
    }

    .quote-form {
        .message {
            font-size: 25px;
            font-weight: bold;
            line-height: 1.32;
            color: $black;
            text-align: center;
            margin: 60px 0 20px;
        }

        .form-row {
            display: flex;
            align-items: center;
            justify-content: space-around;

            &:not(:last-of-type) {
                margin-bottom: 25px;
            }
            .app-date-input {
                @media screen and (max-width: $mobile) {
                    max-width: 190px;
                    margin: 20px auto;
                }
            }
            .app-input {
                width: 100%;
                display: flex;
                margin-bottom: 25px;
                flex-direction: column;
                justify-content: flex-start;

                @media screen and (max-width: $mobile) {
                    margin: 20px auto;
                }
            }

            .app-input-select {
                width: 100%;

                @media screen and (max-width: $mobile) {
                    margin: 20px auto;
                }
            }

            .multiple-inputs {
                width: 100%;
                display: flex;
                justify-content: space-between;

                @media screen and (max-width: $mobile) {
                    max-width: 190px;
                    margin: auto;
                }
                .app-input {
                    max-width: 62px;
                }
            }
        }

        .checkbox {
            margin-bottom: 120px;
            display: flex;
            justify-content: center;
        }

        .submit-row {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
